module.exports = (height, width) => (height / width) * 100;
